export type WappAssistantMode = "exclusive" | "shared";

/** Null until property-manager settings have loaded. */
export function wappAssistantModeFromSettings(
  data: { wappAssistantMode?: unknown } | null | undefined,
): WappAssistantMode | null {
  if (data == null) return null;
  return data.wappAssistantMode === "exclusive" ? "exclusive" : "shared";
}

/**
 * Otros lists people who wrote the company line without a portfolio role.
 * Shared mode ignores those numbers, so the section stays hidden.
 */
export function shouldShowOthersSection(
  hasConnectedNumber: boolean,
  wappAssistantMode: WappAssistantMode | null,
): boolean {
  return hasConnectedNumber && wappAssistantMode === "exclusive";
}
